<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div
    class="flex justify-center flex-auto w-full bg-gray-200 sm:p-4 md:p-8 dark:bg-card h-fit"
>
    <!-- Navigation -->
    <ng-container *ngIf="isScreenSmall">
        <fuse-vertical-navigation
            class="bg-gray-900 dark print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="false"
        >
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div
                    class="flex items-center h-20 px-8 pt-6 cursor-pointer"
                    [routerLink]="['/seller']"
                >
                    <img
                        class="w-30"
                        src="assets/images/logo/logo-text-on-dark.svg"
                    />
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    </ng-container>

    <!-- Wrapper -->
    <div
        class="flex flex-col items-center flex-auto min-w-0 shadow-2xl max-w-360 sm:rounded-xl dark:shadow-none"
    >
        <!-- Header -->
        <div
            class="relative flex items-center w-full h-16 px-4 border-b flex-0 sm:h-20 md:px-6 z-49 bg-card dark:bg-default print:hidden"
        >
            <ng-container >
                <!-- Logo -->
                <div
                    class="flex items-center mx-2 cursor-pointer lg:mr-8"
                    [routerLink]="['/seller']"
                >
                    <div class="hidden lg:flex">
                        <img
                            class="w-24 dark:hidden"
                            src="assets/images/logo/logo-text.svg"
                            alt="Logo image"
                        />
                        <img
                            class="hidden w-24 dark:flex"
                            src="assets/images/logo/logo-text-on-dark.svg"
                            alt="Logo image"
                        />
                    </div>
                    <img
                        class="flex w-8 lg:hidden"
                        src="assets/images/logo/logo.svg"
                        alt="Logo image"
                    />
                </div>
                <!-- Horizontal navigation -->
                <!-- <fuse-horizontal-navigation
                    class="mr-2"
                    [name]="'mainNavigation'"
                    [navigation]="navigation.horizontal"></fuse-horizontal-navigation> -->
            </ng-container>
            <!-- Navigation toggle button -->
            <!-- <ng-container *ngIf="isScreenSmall">
                <button
                    class="mr-2"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                </button>
            </ng-container> -->
            <!-- Components -->
            <div
                class="flex items-center pl-2 space-x-1 sm:space-x-2"
                [ngClass]="{
                    'mr-auto': override.isRTL,
                    'ml-auto': !override.isRTL
                }"
            >
                <!-- <languages></languages> -->
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <!-- <search [appearance]="'bar'"></search> -->
                <!-- <shortcuts></shortcuts> -->
                <!-- <messages></messages> -->
                <!-- <notifications></notifications> -->
                <user></user>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto w-full bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Footer -->
        <div
            class="relative flex items-center justify-start w-full h-16 px-6 border-t flex-0 sm:h-20 sm:px-8 z-49 bg-card dark:bg-default print:hidden"
        >
            <span class="font-medium text-secondary"
                >Shelter-Technology &copy; {{ currentYear }}</span
            >
        </div>
    </div>
</div>
